
import React from "react";
import { NavLink } from "react-router-dom";
import styles from "./WelcomeBanner.module.css";

const WelcomeBanner: React.FC = () => {
  return (
    <section className={styles.Banner}>
      <div className={styles.Text}>
        <div className={styles.Title}>
          Zwiększ widoczność swojej firmy
        </div>

        <p>
          Dodaj firmę do katalogu CARTENA bezpłatnie i bezterminowo.
          Na pierwsze 12 miesięcy otrzymasz pakiet Rozszerzony gratis
          — z logo i zdjęciem firmy.
        </p>
      </div>

      <NavLink to="/addcompany" className={styles.Button}>
        Dodaj firmę za darmo
      </NavLink>
    </section>
  );
};

export default WelcomeBanner;
